// networks.js
export const networks = {
  1: {
    chainId: '0x1',
    chainName: 'Ethereum Mainnet',
    rpcUrls: ['https://mainnet.infura.io/v3/YOUR_INFURA_PROJECT_ID'],
    blockExplorerUrls: ['https://etherscan.io'],
  },
  1313161554: {
    chainId: '0x4e454152',
    chainName: 'Aurora',
    rpcUrls: ['https://mainnet.aurora.dev'],
    blockExplorerUrls: ['https://aurorascan.dev'],
  },
  42161: {
    chainId: '0xa4b1',
    chainName: 'Arbitrum',
    rpcUrls: ['https://arb1.arbitrum.io/rpc'],
    blockExplorerUrls: ['https://arbiscan.io'],
  },
  43114: {
    chainId: '0xa86a',
    chainName: 'Avalanche',
    rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
    blockExplorerUrls: ['https://snowtrace.io'],
  },
  8453: {
    chainId: '0x2105',
    chainName: 'Base',
    rpcUrls: ['https://base-mainnet.infura.io/v3/YOUR_INFURA_PROJECT_ID'],
    blockExplorerUrls: ['https://basescan.org'],
  },
  56: {
    chainId: '0x38',
    chainName: 'BNB Chain',
    rpcUrls: ['https://bsc-dataseed.binance.org/'],
    blockExplorerUrls: ['https://bscscan.com'],
  },
  250: {
    chainId: '0xfa',
    chainName: 'Fantom',
    rpcUrls: ['https://rpc.ftm.tools/'],
    blockExplorerUrls: ['https://ftmscan.com'],
  },
  100: {
    chainId: '0x64',
    chainName: 'Gnosis',
    rpcUrls: ['https://rpc.gnosischain.com/'],
    blockExplorerUrls: ['https://gnosisscan.io'],
  },
  8217: {
    chainId: '0x2019',
    chainName: 'Klaytn',
    rpcUrls: ['https://public-node-api.klaytnapi.com/v1/cypress'],
    blockExplorerUrls: ['https://scope.klaytn.com'],
  },
  10: {
    chainId: '0xa',
    chainName: 'Optimism',
    rpcUrls: ['https://mainnet.optimism.io/'],
    blockExplorerUrls: ['https://optimistic.etherscan.io'],
  },
  137: {
    chainId: '0x89',
    chainName: 'Polygon',
    rpcUrls: ['https://polygon-rpc.com/'],
    blockExplorerUrls: ['https://polygonscan.com'],
  },
  324: {
    chainId: '0x144',
    chainName: 'zkSync Era',
    rpcUrls: ['https://mainnet.era.zksync.io'],
    blockExplorerUrls: ['https://explorer.zksync.io'],
  },
};


/*
ethUnoswap(uint256,uint256)	0xa76dfc3b

minReturn, dex

ethUnoswap2(uint256,uint256,uint256)	0x89af926a

minReturn,dex,dex2

ethUnoswap3(uint256,uint256,uint256,uint256)	0x188ac35d

minReturn,dex,dex2,dex3

ethUnoswapTo(uint256,uint256,uint256)	0x175accdc

to, minReturn, dex

ethUnoswapTo2(uint256,uint256,uint256,uint256)	0x0f449d71

to, minReturn, dex, dex2 

ethUnoswapTo3(uint256,uint256,uint256,uint256,uint256)	0x493189f0

to, minReturn, dex, dex2, dex3

unoswap(uint256,uint256,uint256,uint256)	0x83800a8e

token, amount, minReturn, dex

unoswap2(uint256,uint256,uint256,uint256,uint256)	0x8770ba91

token, amount, minReturn, dex, dex2

unoswap3(uint256,uint256,uint256,uint256,uint256,uint256)	0x19367472

token, amount, minReturn, dex, dex2, dex3

unoswapTo(uint256,uint256,uint256,uint256,uint256)	0xe2c95c82

to, token, amount, minReturn, dex

unoswapTo2(uint256,uint256,uint256,uint256,uint256,uint256)	0xea76dddf

to, token, amount, minReturn, dex, dex2

unoswapTo3(uint256,uint256,uint256,uint256,uint256,uint256,uint256)	0xf7a70056

to, token, amount, minReturn, dex, dex2, dex3
*/